import axios from "../plugins/parseAxios";
export class SettingTaskAPI {
  constructor(props) { }
  static getSettingTasks(payload) {
    return axios.post("functions/getSettingTasksByMarket", payload);
  }
  static getSettingTasksByMarketSmall(payload) {
    return axios.post("functions/getSettingTasksByMarketSmall", payload);
  }
  static getSettingTask(payload) {
    return axios.post("functions/getSettingTask", payload);
  }
  static createSettingTask(payload) {
    return axios.post("functions/createSettingTask", payload);
  }
  static updateSettingTask(payload) {
    return axios.post("functions/updateSettingTask", payload);
  }
  static updateSettingTasks(payload) {
    return axios.post("functions/updateSettingTasks", payload);
  }
  static removeSettingTask(payload) {
    return axios.post("functions/removeSettingTask", payload);
  }
}
